import { render, staticRenderFns } from "./customer-visit-data.vue?vue&type=template&id=10b4dcce&scoped=true"
import script from "./customer-visit-data.vue?vue&type=script&lang=ts"
export * from "./customer-visit-data.vue?vue&type=script&lang=ts"
import style0 from "./customer-visit-data.vue?vue&type=style&index=0&id=10b4dcce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4dcce",
  null
  
)

export default component.exports